export const cntryCrncyList = state => state.ProfileupdateReducer.countryprofdetailList;
export const cntryCrncy = state => state. editshipperprofReducer.countrydetailList;